var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "poi-card"
  }, [_c('div', {
    staticClass: "poi-container",
    class: {
      'poi-container-optimization': _vm.isScreenOptimization
    },
    on: {
      "click": _vm.jumpCityWalk
    }
  }, [_c('div', {
    staticClass: "poi-left"
  }, [_vm.poiBg ? _c('img', {
    staticClass: "poi-bg",
    attrs: {
      "src": _vm.poiBg
    }
  }) : _vm._e(), _c('img', {
    staticClass: "poi-img",
    class: {
      'poi-img-border': _vm.poiBg
    },
    attrs: {
      "src": _vm.poiList[0].image,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "poi-right"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "title-num"
  }, [_vm.poiNum === 1 ? _c('span', [_vm._v("笔记")]) : _vm._e(), _vm._v("提及了" + _vm._s(_vm.poiList[0].name))]), _vm.poiNum > 1 ? _c('span', [_vm._v("等(" + _vm._s(_vm.poiNum) + ")")]) : _vm._e(), _c('div', {
    staticClass: "img"
  })]), !_vm.isScreenOptimization ? _c('div', {
    staticClass: "text"
  }, [_vm._v("进入图区浏览")]) : _vm._e()])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };